import React from "react";
import LeadForm from "./LeadForm";
import soeren from "../../../../img/soeren.png";
import PleaseWait from "./PleaseWait";
import {EVENT_LEAD_CONFIRMED, EVENT_LEAD_FORM_SUBMITTED, EVENT_LEAD_MODAL_CLOSED} from "../Support/Events";
import axios from "axios";
import {LeadModalAlarm} from "../Support/Icon";
import DoiTimeoutError from "./DoiTimeoutError";
import Matomo from "../Support/Matomo";

const VIEW_LEAD_FORM = 'lead-form';
const VIEW_PLEASE_WAIT = 'please-wait';
const VIEW_ERROR = 'error';

const initialState = {
    view: VIEW_LEAD_FORM,
    email: null
}

export default class LeadModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.pollDoiPending = null;
        this.onLeadFormSubmitted = this.onLeadFormSubmitted.bind(this);
        this.doPollDoiPending = this.doPollDoiPending.bind(this);
        this.cancelPollDoiPending = this.cancelPollDoiPending.bind(this);
        this.closeOnEscape = this.closeOnEscape.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        document.addEventListener(EVENT_LEAD_FORM_SUBMITTED, this.onLeadFormSubmitted);
        document.addEventListener('keyup', this.closeOnEscape);

        (new Matomo()).modalOpened();
    }

    onLeadFormSubmitted(event) {
        console.log(event);
        let $this = this;

        this.setState({
            view: VIEW_PLEASE_WAIT,
            email: event.detail.email
        }, function () {
            $this.pollDoiPending = window.setInterval($this.doPollDoiPending, 5 * 1000); // 5 seconds
            window.setTimeout(function () {
                $this.cancelPollDoiPending();
                $this.setState({
                    view: VIEW_ERROR
                });
            }, 5 * 60 * 1000); // 5 minutes
        });
    }

    doPollDoiPending() {
        let $this = this;

        var formData = new FormData();
        formData.append('email', this.state.email);

        axios.post($this.props.apiBase + '/api/result/' + $this.props.result.scan_id + '/lead/doi-pending', formData, { withCredentials: true })
        .catch((error) => {
            console.log('LeadModal 1st catch');
            console.log(error.response);
        })
        .then((response) => {
            if (!response) {
                return;
            }

            if (response.data.double_opt_in_pending === false) {
                $this.cancelPollDoiPending();
                let event = new CustomEvent(EVENT_LEAD_CONFIRMED);
                document.dispatchEvent(event);
                (new Matomo()).doiCompleted();
            }
        }).catch((error) => {
            console.log('LeadModal 2nd catch');
            console.log(error);
            //document.dispatchEvent(new CustomEvent(EVENT_LEAD_MODAL_CLOSED));
        });
    }

    cancelPollDoiPending() {
        if (this.pollDoiPending === null) {
            return;
        }

        window.clearInterval(this.pollDoiPending);
        this.pollDoiPending = null;
    }

    closeOnEscape(event) {
        if (event.key === 'Escape') {
            this.closeModal();
        }
    }

    closeModal() {
        this.cancelPollDoiPending();
        (new Matomo()).modalCancelled();
        document.removeEventListener('keyup', this.closeOnEscape);
        document.dispatchEvent(new CustomEvent(EVENT_LEAD_MODAL_CLOSED));
    }

    render() {
        return (
            <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
                        <div className="lead-modal--main">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="lead-modal--close" onClick={this.closeModal}>
                                <path fillRule="evenodd" clipRule="evenodd" d="M15.2255 0.773473C15.3128 0.860558 15.3821 0.964012 15.4293 1.07791C15.4766 1.19181 15.5009 1.31391 15.5009 1.43722C15.5009 1.56054 15.4766 1.68264 15.4293 1.79654C15.3821 1.91043 15.3128 2.01389 15.2255 2.10097L2.10048 15.226C1.92444 15.402 1.68569 15.5009 1.43673 15.5009C1.18778 15.5009 0.949018 15.402 0.772981 15.226C0.596943 15.0499 0.498047 14.8112 0.498047 14.5622C0.498047 14.3133 0.596943 14.0745 0.772981 13.8985L13.898 0.773473C13.9851 0.686167 14.0885 0.616898 14.2024 0.569636C14.3163 0.522374 14.4384 0.498047 14.5617 0.498047C14.685 0.498047 14.8071 0.522374 14.921 0.569636C15.0349 0.616898 15.1384 0.686167 15.2255 0.773473Z" fill="white"/>
                                <path fillRule="evenodd" clipRule="evenodd" d="M0.773473 0.773473C0.686167 0.860558 0.616898 0.964012 0.569636 1.07791C0.522374 1.19181 0.498047 1.31391 0.498047 1.43722C0.498047 1.56054 0.522374 1.68264 0.569636 1.79654C0.616898 1.91043 0.686167 2.01389 0.773473 2.10097L13.8985 15.226C14.0745 15.402 14.3133 15.5009 14.5622 15.5009C14.8112 15.5009 15.0499 15.402 15.226 15.226C15.402 15.0499 15.5009 14.8112 15.5009 14.5622C15.5009 14.3133 15.402 14.0745 15.226 13.8985L2.10097 0.773473C2.01389 0.686167 1.91043 0.616898 1.79654 0.569636C1.68264 0.522374 1.56054 0.498047 1.43722 0.498047C1.31391 0.498047 1.19181 0.522374 1.07791 0.569636C0.964013 0.616898 0.860558 0.686167 0.773473 0.773473Z" fill="white"/>
                            </svg>
                            {(this.state.view === VIEW_LEAD_FORM) && (
                                <>
                                    <div className="lead-modal--content">
                                        <div className="lead-modal--label">
                                            <strong>eRecht24</strong> Google Fonts Scanner
                                        </div>
                                        <LeadForm
                                            apiBase={this.props.apiBase}
                                            result={this.props.result}
                                        />
                                    </div>
                                    <div className="lead-modal--soeren lead-modal--soeren-bottom">
                                        <img src={this.props.apiBase + soeren} alt="Rechtsanwalt Sören Siebert" />
                                        <div className="lead-modal--soeren--subtitle">
                                            Rechtsanwalt Sören Siebert<br/>
                                            Gründer von eRecht24
                                        </div>
                                    </div>
                                </>
                            )}
                            {(this.state.view === VIEW_PLEASE_WAIT) && (
                                <>
                                    <div className="lead-modal--content lead-modal--please-wait">
                                        <div className="lead-modal--label">
                                            <strong>eRecht24</strong> Google Fonts Scanner
                                        </div>
                                        <PleaseWait></PleaseWait>
                                    </div>
                                    <div className="lead-modal--soeren lead-modal--soeren-top">
                                        <img src={this.props.apiBase + soeren} alt="Rechtsanwalt Sören Siebert" />
                                        <div className="lead-modal--soeren--subtitle">
                                            Rechtsanwalt Sören Siebert<br/>
                                            Gründer von eRecht24
                                        </div>
                                    </div>
                                </>
                            )}
                            {(this.state.view === VIEW_ERROR) && (
                                <>
                                    <div className="lead-modal--content lead-modal--error">
                                        <div className="lead-modal--label">
                                            <strong>eRecht24</strong> Google Fonts Scanner
                                        </div>
                                        <DoiTimeoutError></DoiTimeoutError>
                                    </div>
                                    <div className="lead-modal--error-icon">
                                        <LeadModalAlarm/>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
